export const SUPPORT_EMAIL = 'controlapag@controlapag.com.br';

export const SUPPORT_HOURS = 'Segunda a sexta, das 9h às 18h (horário de Brasília)';

export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent('Suporte Controlapag')}`;
